/**
 * Route for `custom-url-scheme`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CustomUrlSchemePage } from "../features/custom-url-scheme/CustomUrlSchemePage";

export const customUrlSchemeRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/custom-url-scheme",
	component: CustomUrlSchemePage,
});

export default customUrlSchemeRoute;
